import { Button } from '@104ha/base-ui';
import { useRef } from 'react';
import Page, { TopBar } from '../../components/page';
import { useDialog } from '../../hook/use-dialog';
import { BrowseProvilegeDialog } from 'open-api-client/src/page/api-permission/browse-privilege';
import { EditAccountDialog } from './edit';
import { EditPasswordDialog } from './edit-password';
import { EditPrivilegeDialog } from 'open-api-client/src/page/api-permission/edit-privilege';
import { Grid } from './grid';
import { NewAccountDialog } from './new';

export default function ApiPermission() {
	// const [showNewDialog, setShowNewDialog] = useState(false);
	// const [showEditDialog, setShowEditDialog] = useState<any>(null);
	const gridRef = useRef<Grid>(null);
	// const editDlgRef = useRef<EditAccountDialog>(null);
	const [_EditAccountDialog, setEditDialog] = useDialog(EditAccountDialog);
	const [_NewAccountDialog, setNewDialog] = useDialog(NewAccountDialog);
	const [_EditPasswordDialog, setEditPasswordDialog] = useDialog(EditPasswordDialog);
	const [_BrowseProvilegeDialog, setBrowseProvilegeDialog] = useDialog(BrowseProvilegeDialog);
	const [_EditPrivilegeDialog, setEditPrivilegeDialog] = useDialog(EditPrivilegeDialog);

	const reload = () => {
		gridRef.current?.reload();
	};

	return (
		<Page>
			<TopBar>
				<Button.New onClick={() => setNewDialog(true)}>新增帳號</Button.New>
			</TopBar>
			<Grid
				ref={gridRef}
				openEditDialog={(rowData) =>
					setEditDialog({
						...rowData,
						accountStatus: rowData.accountStatus === 3 ? 1 : 0,
					})
				}
				openEditPasswordDialog={(rowData) => {
					setEditPasswordDialog(rowData);
				}}
				openBrowseDialog={(rowData) => {
					setBrowseProvilegeDialog(rowData);
				}}
				openEditPrivilageDialog={(rowData) => {
					setEditPrivilegeDialog(rowData);
				}}
			></Grid>
			<_NewAccountDialog onSuccess={() => reload()} />
			<_EditPasswordDialog onSuccess={() => reload()} />
			<_BrowseProvilegeDialog />
			<_EditPrivilegeDialog onSuccess={() => reload()} />
			<_EditAccountDialog onSuccess={() => reload()} />
		</Page>
	);
}
